export default function counter() {
  const counters = document.querySelectorAll('.js-number-counter')

  if (counters.length > 0) {
    counters.forEach(counter => {
      const initialValue = counter.getAttribute('data-initial-value')
      const finalValue = counter.getAttribute('data-final-value')
      const duration = counter.getAttribute('data-duration')
    
      let animateValue = (counter, start, end, duration) => {
        let startTimestamp = null
    
        const step = timestamp => {
          if (!startTimestamp) startTimestamp = timestamp
    
          const progress = Math.min((timestamp - startTimestamp) / duration, 1)
    
          counter.innerText = Math.floor(progress * (end - start) + start)
    
          if (progress < 1) {
            window.requestAnimationFrame(step)
          }
        }
    
        window.requestAnimationFrame(step)
      }
    
      let observer = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting === true)
          // Element is fully visible
          animateValue(counter, parseInt(initialValue), parseInt(finalValue), duration)
      }, {
        threshold: [1]
      })
    
      observer.observe(counter)
    })
  }
}